export { default as ColorSwatchOutlineIcon } from './ColorSwatchOutlineIcon';
